import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-754c5989"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "task-subtasks-search-dropdown__option-taskid" }
const _hoisted_3 = { class: "task-subtasks-search-dropdown__option-name" }
const _hoisted_4 = { class: "task-subtasks-search-dropdown__status" }

import { computed, PropType, ref } from 'vue';
import {
  PopoverPositionType,
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmMultiselect,
  TirPmRouterLink,
} from 'tir-components';
import { SubtasksSearchFunctionType } from './types';
import { TaskOptionModel, TasksRequestModel } from './models';
import { debounce } from 'tir-pm-debounce';
import { TaskDrawer, TaskDrawerSettingsModel } from '../task-drawer';
import { PlusIcon } from 'tir-style-system/icons/outline';
import { TaskModel } from '../task-drawer/models';
import { useRouter } from 'vue-router';

/**Роутер */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-subtasks-search-dropdown',
  props: {
  /**Редактируемая задача */
  editTaskInfo: { type: Object as PropType<TaskModel> },
  /**Внутри шторки */
  inDrawer: { type: Boolean, default: false },
  /**ID очереди */
  queueId: { type: String },
  /**ID задачи */
  taskId: { type: Number },
  /**Функция поиска */
  searchFunction: {
    type: Function as PropType<SubtasksSearchFunctionType>,
    required: true,
  },
  /**Шаг поиска */
  step: {
    type: Number,
    default: 10,
  },
  /**Отключить поповер */
  isDisabled: {
    type: Boolean,
    default: false,
  },
  /**Позиционирование по правому краю */
  isRight: {
    type: Boolean,
    default: false,
  },
  /**Игнорирование задач */
  ignoreTasks: {
    type: Array as PropType<Array<number>>,
    default: [],
  },
  /**Кастомная позиция поповера */
  customPopoverPosition: {
    type: Object as PropType<PopoverPositionType>,
  },
  /**Не телепортировать */
  noTeleport: {
    type: Boolean,
    default: false,
  },
  /**Отключение потери фокуса при клике по контенту */
  disableContentBlur: {
    type: Boolean,
    default: false,
  },
  /**Закрыть при выборе */
  closeBySelect: {
    type: Boolean,
    default: false,
  },
  /**Всегда показывать список */
  staticScrollHeight: { type: Boolean },
  /**Разрешено ли создание подзадачи */
  allowCreateSubtask: { type: Boolean, default: false },
},
  emits: ["onSelect", "onCreatedSubtask", "onUpdatedSubtask", "updateVisiblePopover"],
  setup(__props, { emit }) {

const props = __props;

const router = useRouter();

/**Параметры */

/**События */


/**Ссылка на компонент мультиселекта */
const $multiselect = ref<{ close: () => void }>();
/**Ссылка на компонент шторки задач */
const $taskDrawer = ref<InstanceType<typeof TaskDrawer>>();

/**Открыть модальное окно создания подзадачи */
const openCreateSubtask = () => {
  if (props.taskId && props.allowCreateSubtask && !props.inDrawer) {
    $multiselect.value?.close();
    $taskDrawer.value?.open(
      new TaskDrawerSettingsModel({
        Mode: 'create-subtask',
        ParentTaskId: props.taskId,
      }),
    );
  }
};
/**Выбор задачи */
const onSelect = (taskId: number) => {
  emit('onSelect', taskId);
  $multiselect.value?.close();
};

/**При создании задачи */
const onCreateTask = (task: TaskModel) => {
  emit('onCreatedSubtask', task.Id);
};

/**При обновлении задачи */
const onUpdateTask = (task: TaskModel) => {
  emit('onUpdatedSubtask', task.Id);
};

/**Позиция поповера */
const popoverPosition = computed<PopoverPositionType>(() => {
  if (props.customPopoverPosition) return props.customPopoverPosition;
  if (props.isRight)
    return {
      right: '0rem',
      top: '$el:height + 0.25rem',
    };
  return {
    left: '0rem',
    top: '$el:height + 0.25rem',
  };
});
/**Путь до деталки род. задачи */
const parentTaskDetailPath = computed(() => {
  return router.resolve({
    name: 'task-detail',
    params: {
      projectId: props.editTaskInfo?.ProjectId,
      namespaceId: props.editTaskInfo?.NamespaceId,
      queueId: props.editTaskInfo?.QueueTaskId,
      taskId: props.editTaskInfo?.Id,
    },
    query: {
      isOpenCreateSubtask: 'true',
    },
  });
});

/**Опции */
const options = ref(new Array<TaskOptionModel>());
/**Отображаемы опции */
const viewOptions = computed(() =>
  options.value.filter((option) => !props.ignoreTasks.includes(option.Id)),
);
/**Загрузка */
const isLoading = ref(false);
/**Кол-во задач */
let countTasks: number | undefined;
/**Запрос */
const pageRequest = ref(
  new TasksRequestModel({
    QueueId: props.queueId,
    SearchValue: '',
    Skip: 0,
    Take: props.step,
  }),
);

/**Поиск задач */
const searchTasks = async () => {
  isLoading.value = true;
  const resp = await props.searchFunction(pageRequest.value);
  isLoading.value = false;

  if (resp.IsSuccess) {
    options.value.push(
      ...resp.Items.map(
        (task) =>
          new TaskOptionModel({
            Id: task.Id,
            Code: task.Code,
            Name: task.Name,
            StatusColor: task.Status.Color,
            StatusName: task.Status.Name,
          }),
      ),
    );
    pageRequest.value.Skip += resp.Size;
    countTasks = resp.Count;
  }
};

/**При обновлении строки поиска */
const onSearch = async () => {
  // Сброс страниц
  pageRequest.value.Skip = 0;
  isLoading.value = true;
  const resp = await props.searchFunction(pageRequest.value);
  isLoading.value = false;

  if (resp.IsSuccess) {
    options.value = resp.Items.map(
      (task) =>
        new TaskOptionModel({
          Id: task.Id,
          Code: task.Code,
          Name: task.Name,
          StatusColor: task.Status.Color,
          StatusName: task.Status.Name,
        }),
    );
    pageRequest.value.Skip += resp.Size;
    countTasks = resp.Count;
  }
};

const debounceOnSearch = debounce(onSearch, 400);

const updateSearch = (value: string) => {
  // Установка строки поиска
  pageRequest.value.SearchValue = value;

  debounceOnSearch();
};

/**
 *  Проверить проскроллен ли элемент до конца
 * @param element Элемент
 * @returns
 */
const checkScrolledToBottom = (element: HTMLElement): boolean =>
  element.scrollTop + element.clientHeight + 100 >= element.scrollHeight;

/**При скролле */
const onScoll = (event: any) => {
  const target = event.target as HTMLElement | undefined;
  if (
    !target ||
    !checkScrolledToBottom(target) ||
    isLoading.value ||
    pageRequest.value.Skip >= countTasks
  )
    return;

  searchTasks();
};

/**Сброс данных */
const reset = () => {
  pageRequest.value = new TasksRequestModel({
    SearchValue: '',
    Skip: 0,
    Take: props.step,
  });
  countTasks = undefined;
  options.value = [];
};

const onOpen = () => {
  emit('updateVisiblePopover', true);
  searchTasks();
};

const onClose = () => {
  reset();
  emit('updateVisiblePopover', false);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmMultiselect), {
    ref_key: "$multiselect",
    ref: $multiselect,
    class: "task-subtasks-search-dropdown",
    "popover-classes": "task-subtasks-search-dropdown__popover",
    "search-input-label": "Поиск по номеру или названию задачи",
    "is-search-local": false,
    "popover-width": "32.5rem",
    staticScrollHeight: __props.staticScrollHeight,
    "popover-position": popoverPosition.value,
    "is-disabled-popover": __props.isDisabled,
    options: viewOptions.value,
    "no-teleport": __props.noTeleport,
    "disable-content-blur": __props.disableContentBlur,
    "search-input-autofocus": "",
    onOnScroll: onScoll,
    onUpdateSearch: updateSearch,
    onEnter: onSearch,
    onOnOpen: onOpen,
    onOnClose: onClose
  }, {
    target: _withCtx(() => [
      _renderSlot(_ctx.$slots, "target"),
      _createVNode(_unref(TaskDrawer), {
        ref_key: "$taskDrawer",
        ref: $taskDrawer,
        onOnCreateTask: onCreateTask,
        onOnUpdateTask: onUpdateTask
      }, null, 512)
    ]),
    optionList: _withCtx(({ option }) => [
      _createElementVNode("div", {
        class: "task-subtasks-search-dropdown__option",
        onClick: ($event: any) => (onSelect(option.Id))
      }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(option.Id), 1),
        _createElementVNode("span", _hoisted_3, _toDisplayString(option.Name), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "task-subtasks-search-dropdown__status-dot",
            style: _normalizeStyle({ backgroundColor: option.StatusColor })
          }, null, 4),
          _createElementVNode("span", {
            class: "task-subtasks-search-dropdown__status-name",
            style: _normalizeStyle({ color: option.StatusColor })
          }, _toDisplayString(option.StatusName), 5),
          _createElementVNode("div", {
            class: "task-subtasks-search-dropdown__status-bg",
            style: _normalizeStyle({ backgroundColor: option.StatusColor })
          }, null, 4)
        ])
      ], 8, _hoisted_1)
    ]),
    optionListBottom: _withCtx(() => [
      _createVNode(_unref(TirPmRouterLink), {
        to: parentTaskDetailPath.value,
        isDisabled: !__props.inDrawer,
        target: "_blank"
      }, {
        default: _withCtx(() => [
          (__props.taskId && __props.allowCreateSubtask)
            ? (_openBlock(), _createBlock(_unref(TirPmButton), {
                key: 0,
                size: _unref(TirPmButtonSizeEnum).Regular,
                variant: _unref(TirPmButtonVariantEnum).LinkState,
                style: {"width":"100%"},
                onClick: openCreateSubtask
              }, {
                leftSlot: _withCtx(() => [
                  _createVNode(_unref(PlusIcon))
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" Создать новую ")
                ]),
                _: 1
              }, 8, ["size", "variant"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["to", "isDisabled"])
    ]),
    _: 3
  }, 8, ["staticScrollHeight", "popover-position", "is-disabled-popover", "options", "no-teleport", "disable-content-blur"]))
}
}

})